import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from './storage.service';
import {RedirectService} from './redirect.service';

const GUEST_MODE_KEY = 'guestMode';

@Injectable({
  providedIn: 'root'
})
export class GuestSessionService {
  private storageService = inject(StorageService);
  private redirectService = inject(RedirectService);
  private router = inject(Router);

  async setGuest(): Promise<void> {
    await this.storageService.set(GUEST_MODE_KEY, true);
  }

  async clearGuest(): Promise<void> {
    await this.storageService.remove(GUEST_MODE_KEY);
  }

  async isGuest(): Promise<boolean> {
    return !!(await this.storageService.get(GUEST_MODE_KEY));
  }

  async isLoggedIn(): Promise<boolean> {
    return !!(await this.storageService.get('user'));
  }

  /**
   * Gate for guest-blocked actions. Returns true when a real user is logged in.
   * Otherwise stores the intended url, navigates to login, and returns false.
   */
  async requireLogin(intendedUrl: string): Promise<boolean> {
    if (await this.isLoggedIn()) {
      return true;
    }
    await this.redirectService.setRedirectUrl(intendedUrl);
    await this.router.navigate(['/login']);
    return false;
  }
}
